import { useEffect, useMemo, useState } from 'react'

import { calculateImageAspectRatio } from './helpers'

export const useGetImageMediaRatio = mediaUrl => {
  const [mediaRatio, setMediaRatio] = useState('')
  const [isMediaError, setIsMediaError] = useState(false)

  useEffect(() => {
    calculateImageAspectRatio(mediaUrl)
      .then(aspectRatio => {
        setMediaRatio(aspectRatio)
        setIsMediaError(false)
      })
      .catch(error => {
        console.error('Error calculating image aspect ratio:', error)
        setIsMediaError(true)
        setMediaRatio('')
      })
  }, [mediaUrl, setMediaRatio])

  return { mediaRatio, isMediaError }
}

export const useIsStoryRatio = ratio => {
  // This hook calculates and determines if the aspect ratio of a media item (image or video) matches the story format (9:16).
  // this hook is used when we can't determine the placement positions, so we need to check the media ratio instead
  return useMemo(() => Number(ratio) === 9 / 16, [ratio])
}
